import React, { useState, useEffect } from   'react';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { useAuth } from '../../../Auth/AuthContext';
import SeccionPageHeader from '../../Utils/SeccionPageHeader';
import CargandoSpinner from '../../Utils/CargandoSpinner';

export default function PasarIntegranteFamilia(){
    const { token, user } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [idPersonaSeparar, setIdPersonaSeparar] = useState('');
    const [familiaSeparar, setFamiliaSeparar] = useState([]);
    const [idJefeDestino, setIdJefeDestino] = useState('');
    const [familiaDestino, setFamiliaDestino] = useState([]);
    const [familiaSeparada, setFamiliaSeparada] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10); 
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [swalProps, setSwalProps] = useState({});
    
    useEffect(() => {
    }, []);
    const BuscarPersonaSeparar = async (idPersona) => {
        const url = '/caracterizacion/consultarpersonaseparar';
        const obj = {
            idPersona: idPersona,
        };
        try {
        setCargando(true);
        const response = await apiService.post(url, obj, token);
        const result = await response.data;
        setFamiliaSeparar(result.integrantes);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    const BuscarFamiliaDestino = async (idJefe) => {
        const url = '/caracterizacion/consultarfamiliadestinoseparar';
        const obj = {
            idJefe: idJefe,
        };
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setFamiliaDestino(result.integrantes);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const BuscarPersonaSeparada = async (idPersona) => {
        const url = '/caracterizacion/consultarpersonaseparar';
        const obj = {
            idPersona: idPersona,
        };
        try {
        setCargando(true);
        const response = await apiService.post(url, obj, token);
        const result = await response.data;
        setFamiliaSeparada(result.integrantes);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function mensajeSeparar(title, text) {
        return new Promise((resolve) => {
            setSwalProps({
            show: true,
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => resolve(true),
            didClose: () => resolve(false),
            });
        });
    }
    async function Separar(row){
        const confirmSeparar = await mensajeSeparar("Separar a otra familia", `¿Está seguro de que desea pasar a ${row.nombre} a otra familia?`);
        if (!confirmSeparar) {
            return;
        }
        setCargando(true);
        const url = '/caracterizacion/separarpersonaaotrafamilia';
        const obj = {
            idPersona: row.per_idpersona,
            idCabezaFamiliaDestino: familiaDestino[0].gru_idcabezafamilia,
            usrId: user,
        };
        try {
            const response = await apiService.post(url, obj, token);
            if(response.status === 200){
                BuscarPersonaSeparar(row.gru_idcabezafamilia);
                BuscarPersonaSeparada(row.per_idpersona);
                Mensaje('Separar', JSON.stringify(response.data.message));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Separar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Separar', JSON.stringify(error.response.data));
            }else{
                if (error.response?.data) {
                    Mensaje('Separar', JSON.stringify(error.response.data));
                } else {
                    Mensaje('Separar', 'Ocurrió un error inesperado.');
                }
            }
        } finally {
            setCargando(false);
        }
    }    
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    return (
        <div className="content-wrapper">
            <SeccionPageHeader  
                title="Administrar familias - Separar persona a otra familia"
                idCabezaFamilia="1"
                url="/caracterizacion/administrarcaracterizacion"
                nombreurl="Administrar caracterización"
                nombreform=" Separar persona a otra familia"
            />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario Separar persona a otra familia</h3>
                            </div>
                            <div className='card-body'>
                                <div className="row">
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buscar ID Persona"
                                            value={idPersonaSeparar}
                                            onChange={(e) => setIdPersonaSeparar(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => BuscarPersonaSeparar(idPersonaSeparar)}
                                        >
                                            Buscar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {familiaSeparar && familiaSeparar.length > 0 &&
                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <h5>Familia Actual</h5>
                                    <DataTable
                                        columns={[
                                            { name: 'ID Persona', selector: row => row.per_idpersona, sortable: true,},
                                            { name: 'ID Jefe de hogar', selector: row => row.gru_idcabezafamilia, sortable: true,},
                                            { name: 'Nombre', selector: row => row.nombre, sortable: true,},
                                            { name: 'Parentesco', selector: row => row.par_parentesco, sortable: true, },
                                            { name: 'Acciones', cell: row => (
                                                    row.par_parentesco !== 'Jefe de Hogar' &&
                                                    familiaDestino && 
                                                    familiaDestino.length > 0 && 
                                                    (
                                                        <button type="button" className="btn btn-sm btn-primary" onClick={() => Separar(row)}>
                                                            Separar a otra familia
                                                        </button>
                                                    )
                                                ),
                                            },
                                        ]}
                                        data={familiaSeparar}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        onChangePage={page => setCurrentPage(page)}
                                        onChangeRowsPerPage={newPerPage => setPerPage(newPerPage)}
                                        highlightOnHover
                                        pointerOnHover
                                        noDataComponent="No hay datos para mostrar"
                                    />
                                </div>
                            </div>}
                            {familiaSeparar && familiaSeparar.length > 0 &&
                            <div className='card-body'>
                                <div className="row">
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buscar ID Jefe de hogar destino"
                                            value={idJefeDestino}
                                            onChange={(e) => setIdJefeDestino(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => BuscarFamiliaDestino(idJefeDestino)}
                                        >
                                            Buscar
                                        </button>
                                    </div>
                                </div>
                            </div>}
                            {familiaDestino && familiaDestino.length > 0 && 
                             <div className="row mt-3">
                                <div className="col-md-12">
                                    <h5>Familia Destino</h5>
                                    <DataTable
                                        columns={[
                                            { name: 'ID Persona', selector: row => row.per_idpersona, sortable: true,},
                                            { name: 'ID Jefe de hogar', selector: row => row.gru_idcabezafamilia, sortable: true,},
                                            { name: 'Nombre', selector: row => row.nombre, sortable: true,},
                                            { name: 'Parentesco', selector: row => row.par_parentesco, sortable: true, },
                                        ]}
                                        data={familiaDestino}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        onChangePage={page => setCurrentPage(page)}
                                        onChangeRowsPerPage={newPerPage => setPerPage(newPerPage)}
                                        highlightOnHover
                                        pointerOnHover
                                        noDataComponent="No hay datos para mostrar"
                                    />
                                </div>
                            </div>}
                            {familiaSeparada && familiaSeparada.length > 0 && 
                             <div className="row mt-3">
                                <div className="col-md-12">
                                    <h5>Resultado Mover Persona</h5>
                                    <DataTable
                                        columns={[
                                            { name: 'ID Persona', selector: row => row.per_idpersona, sortable: true,},
                                            { name: 'ID Jefe de hogar', selector: row => row.gru_idcabezafamilia, sortable: true,},
                                            { name: 'Nombre', selector: row => row.nombre, sortable: true,},
                                            { name: 'Parentesco', selector: row => row.par_parentesco, sortable: true, },
                                        ]}
                                        data={familiaSeparada}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        onChangePage={page => setCurrentPage(page)}
                                        onChangeRowsPerPage={newPerPage => setPerPage(newPerPage)}
                                        highlightOnHover
                                        pointerOnHover
                                        noDataComponent="No hay datos para mostrar"
                                    />
                                </div>
                            </div>}
                        </div> 
                    
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}